import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/api/index'

import Nprogress from 'nprogress';
import globalAxios from 'axios'

import router from '@/router/index'
import qs from 'qs'
Vue.use(Vuex)
const state = {
  adminDetailsList: [],
  adminRoleList: [],
  adminControlList: [],
  adminClassifyList: [],
  cdnHost:"",
  adminLocations: []
}

const mutations = {
  CLEAR_ADMINS_STATE(state) {
    state.adminDetailsList = [];
    state.adminRoleList = [];
    state.adminControlList = [];
    state.adminClassifyList = [];
    state.adminLocations = [];
  },
  SET_ADMIN_DETAILS_LIST(state, adminDetails) {
    var tData = {};
    var parseData = JSON.parse(adminDetails.message);
    if (parseData != null) {
      tData[parseData.account_id + '-adminDetailsList'] = parseData;
      state.adminDetailsList = tData;
      state.adminLocations = [];
      for(var i = 0; i < tData[parseData.account_id + '-adminDetailsList'].adminDatas.length ; i++){
        var dat = {};
        dat['adminId'] = state.adminDetailsList[parseData.account_id + '-adminDetailsList'].adminDatas[i].Admin.id;
        dat['latitude'] = state.adminDetailsList[parseData.account_id + '-adminDetailsList'].adminDatas[i].AdminLocations.latitude;
        dat['longitude'] = state.adminDetailsList[parseData.account_id + '-adminDetailsList'].adminDatas[i].AdminLocations.longitude;
        dat['srclat'] = state.adminDetailsList[parseData.account_id + '-adminDetailsList'].adminDatas[i].AdminLocations.latitude;
        dat['srclong'] = state.adminDetailsList[parseData.account_id + '-adminDetailsList'].adminDatas[i].AdminLocations.longitude;
        state.adminLocations.push(dat);
      }
    }
  },
  ADD_ADMIN_LIST(state, data) {
    var admin = data.admindata.adminDatas;
    if (admin.length > 0) {
      for (var i = 0; i < admin.length; i++) {
        var index = state.adminDetailsList[data.accountId + "-adminDetailsList"].adminDatas.findIndex(adId => adId.Admin.id == admin[i].Admin.id);
        if (index != '-1') {
          state.adminDetailsList[data.accountId + "-adminDetailsList"].adminDatas.splice(index, 1)
        }
        state.adminDetailsList[data.accountId + "-adminDetailsList"].adminDatas.push(admin[i]);

      }
    }
  },
  DEACTIVATE_ADMIN(state, data) {
    var adminData = data.userId;
    var accountId = data.accountId;
    var index = state.adminDetailsList[data.accountId + "-adminDetailsList"].adminDatas.findIndex(adId => adId.Admin.id == adminData);
    if (index != '-1') {
      if (state.adminDetailsList[data.accountId + "-adminDetailsList"].adminDatas[index].Admin.status == 'active') {
        state.adminDetailsList[data.accountId + "-adminDetailsList"].adminDatas[index].Admin.status = 'inactive';
      } else {
        state.adminDetailsList[data.accountId + "-adminDetailsList"].adminDatas[index].Admin.status = 'active';
      }
    }
  },
  DELETE_ADMIN(state, data) {
    var adminData = data.userId;
    var accountId = data.accountId;
    var index = state.adminDetailsList[data.accountId + "-adminDetailsList"].adminDatas.findIndex(adId => adId.Admin.id == adminData);
    if (index != '-1') {
      state.adminDetailsList[data.accountId + "-adminDetailsList"].adminDatas.splice(index, 1);
    }
  },
  ENABLE_EMAIL_NOTIFICATION(state, data) {
    var adminData = data.userId;
    var accountId = data.accountId;
    var index = state.adminDetailsList[data.accountId + "-adminDetailsList"].adminDatas.findIndex(adId => adId.Admin.id == adminData);
    if (index != '-1') {
      if (state.adminDetailsList[data.accountId + "-adminDetailsList"].adminDatas[index].Admin.enable_email_notification != true) {
        state.adminDetailsList[data.accountId + "-adminDetailsList"].adminDatas[index].Admin.enable_email_notification = true;
      } else {
        state.adminDetailsList[data.accountId + "-adminDetailsList"].adminDatas[index].Admin.enable_email_notification = false;
      }
    }
  },
  CHANGE_ADMIN_GROUP(state, data) {
    var adminid = data.adminId;
    var admin_gruop_id = data.role;
    var accountId = data.accountId;
    if (admin_gruop_id == "1") {
      var roleName = 'super';
    }
    for (var i = 0; i < state.adminDetailsList[accountId + '-adminDetailsList'].adminRoles.length; i++) {
      if (state.adminDetailsList[accountId + '-adminDetailsList'].adminRoles[i].AdminGroup.id == admin_gruop_id) {
        var roleName = state.adminDetailsList[accountId + '-adminDetailsList'].adminRoles[i].AdminGroup.name;
      }
    }
    for (var i = 0; i < state.adminDetailsList[accountId + '-adminDetailsList'].adminDatas.length; i++) {
      if (state.adminDetailsList[accountId + '-adminDetailsList'].adminDatas[i].Admin.id == adminid) {
        state.adminDetailsList[accountId + '-adminDetailsList'].adminDatas[i].Admin.admin_group_id = admin_gruop_id;
        state.adminDetailsList[accountId + '-adminDetailsList'].adminDatas[i].AdminGroup.name = roleName;
      }
    }
    state.adminDetailsList = state.adminDetailsList;
  },
  CHANGE_ADMIN_EMAIL(state, data) {
    var adminid = data.adminId;
    var adminEmail = data.email;
    var accountId = data.accountId;

    for (var i = 0; i < state.adminDetailsList[accountId + '-adminDetailsList'].adminDatas.length; i++) {
      if (state.adminDetailsList[accountId + '-adminDetailsList'].adminDatas[i].Admin.id == adminid) {
        state.adminDetailsList[accountId + '-adminDetailsList'].adminDatas[i].Admin.email = adminEmail;
      }
    }
    state.adminDetailsList = state.adminDetailsList;
  },
  CHANGE_ADMIN_MANAGER(state, data) {
    var adminid = data.adminId;
    var manager = data.manager;
    var accountId = data.accountId;

    for (var i = 0; i < state.adminDetailsList[accountId + '-adminDetailsList'].adminDatas.length; i++) {
      if (state.adminDetailsList[accountId + '-adminDetailsList'].adminDatas[i].Admin.id == adminid) {
        state.adminDetailsList[accountId + '-adminDetailsList'].adminDatas[i].Admin.manager = manager;
      }
    }
    state.adminDetailsList = state.adminDetailsList;
  },
  CHANGE_ADMIN_PHONE(state, data) {
    var adminid = data.adminId;
    var adminPhone = data.phone;
    var accountId = data.accountId;

    for (var i = 0; i < state.adminDetailsList[accountId + '-adminDetailsList'].adminDatas.length; i++) {
      if (state.adminDetailsList[accountId + '-adminDetailsList'].adminDatas[i].Admin.id == adminid) {
        state.adminDetailsList[accountId + '-adminDetailsList'].adminDatas[i].Admin.phone = adminPhone;
      }
    }
    state.adminDetailsList = state.adminDetailsList;
  },
  CHANGE_ADMIN_PASS(state, data) {
    var adminid = data.adminId;
    var adminPass = data.pass;
    var accountId = data.accountId;

    for (var i = 0; i < state.adminDetailsList[accountId + '-adminDetailsList'].adminDatas.length; i++) {
      if (state.adminDetailsList[accountId + '-adminDetailsList'].adminDatas[i].Admin.id == adminid) {
        state.adminDetailsList[accountId + '-adminDetailsList'].adminDatas[i].Admin.password = adminPass;
      }
    }
    state.adminDetailsList = state.adminDetailsList;
  },
  SET_ADMIN_ROLES_DETAILS(state, data) {
    var tData = {};
    var parseData = data.message;
    if (Object.keys(state.adminRoleList).length == 0) {
      tData[data.accountId + '-adminRoleList'] = parseData;
      state.adminRoleList = tData;
    } else {
      Vue.set(state.adminRoleList, data.accountId + '-adminRoleList', parseData);
    }
  },
  SET_ADMIN_CONTROL(state, adContData) {
    var tData = {};
    var parseData = adContData.message;
    state.cdnHost = adContData.cdnHost;
    if (Object.keys(state.adminControlList).length == 0) {
      tData[adContData.accountId + '-adminControlList'] = parseData;
      state.adminControlList = tData;
    } else {
      Vue.set(state.adminControlList, adContData.accountId + '-adminControlList', parseData);
    }
  },
  DELETE_ADMIN_ROLE_LIST(state, data) {
    var adIds = data.adData;
    var accountId = data.accountId;
    if (Object.keys(state.adminRoleList).length != 0) {
      var index = state.adminRoleList[accountId + "-adminRoleList"].adminGroupNames.findIndex(adminRole => adminRole.AdminGroup.id == adIds);
      if (index != -1) {
        state.adminRoleList[accountId + "-adminRoleList"].adminGroupNames.splice(index, 1);
        state.adminRoleList[accountId + "-adminRoleList"].adminids.splice(index, 1);
      }
    }
  },
  ADD_ADMIN_ROLE_LIST(state, data) {
    var adData = data.adData;
    var accountId = data.accountId;
    var adGrpLen = adData.adminGroupNames.length;
    var adGrpData = adData.adminGroupNames;

    if (Object.keys(state.adminRoleList).length != 0 && state.adminRoleList != 'noData') {
      for (var i = 0; i < adGrpLen; i++) {
        var index = state.adminRoleList[accountId + "-adminRoleList"].adminGroupNames.findIndex(adminRole => adminRole.AdminGroup.name == adGrpData[i].AdminGroup.name);
        if (index != -1) {
          state.adminRoleList[accountId + "-adminRoleList"].adminGroupNames.splice(index, 1, adGrpData[i]);
          state.adminRoleList[accountId + "-adminRoleList"].adminids.splice(index, 1, adData.adminids[i]);
        } else {
          state.adminRoleList[accountId + "-adminRoleList"].adminGroupNames.push(adGrpData[i]);
          state.adminRoleList[accountId + "-adminRoleList"].adminids.push(adData.adminids[i]);
        }
      }
    } else {
      var dataSet = {}
      dataSet[accountId + "-adminRoleList"] = adData;
      state.adminRoleList = dataSet;
    }
  },
  SET_ADMIN_CLASSIFICATION_DETAILS(state, data) {
    var tData = {};
    var parseData = data.message;
    if (Object.keys(state.adminClassifyList).length == 0) {
      tData[data.accountId + '-adminClassifyList'] = parseData;
      tData.accountidd = data.accountId;
      state.adminClassifyList = tData;
    } else {
      Vue.set(state.adminClassifyList, data.accountId + '-adminClassifyList', parseData);
    }
  },
  ADD_ADMIN_CLASSIFY_LIST(state, data) {
    var adminData = data.adminData;
    var accountId = data.accountId;
    if (Object.keys(state.adminClassifyList).length != 0 && state.adminClassifyList != 'noData') {
      state.adminClassifyList[accountId + "-adminClassifyList"].getAdminsData.push(adminData);
    } else {
      var dataSet = {}
      dataSet[accountId + "-adminClassifyList"] = adminData;
      state.adminClassifyList = dataSet;
    }
  },
  REMOVE_ADMIN_FROM_GROUP(state, data) {
    var adIds = data.id;
    var accountId = data.accountId;
    var ind = data.ind;
    if (Object.keys(state.adminClassifyList).length != 0) {
      var index = state.adminClassifyList[accountId + "-adminClassifyList"].getAdminsData[ind].addedadmins.findIndex(adminClassify => adminClassify.id == adIds);
      if (index != -1) {
        state.adminClassifyList[accountId + "-adminClassifyList"].getAdminsData[ind].addedadmins.splice(index, 1);
      }
    }
  },
  ADD_ADMIN_TO_GROUP(state, data) {
    var adData = data.adminData;
    var accountId = data.accountId;
    var ind = data.ind;
    if (Object.keys(state.adminClassifyList[accountId + "-adminClassifyList"].getAdminsData[ind]).length > 3) {
      state.adminClassifyList[accountId + "-adminClassifyList"].getAdminsData[ind].addedadmins.push(adData);
    } else {
      var test = {};
      test['0'] = adData;
      state.adminClassifyList[accountId + "-adminClassifyList"].getAdminsData[ind].addedadmins = test;
    }
  },
  SOCKET_SETADMINLOCATIONDATA(state, data) {
    var adminLocationData = JSON.parse(data);
    console.log("adminLocationData ",adminLocationData);

    var adminData = adminLocationData.admin_id;
    var accountId = adminLocationData.accountId;
    var index = state.adminDetailsList[accountId + "-adminDetailsList"].adminDatas.findIndex(adId => adId.Admin.id == adminData);
    if (index != '-1') {
      state.adminDetailsList[accountId + "-adminDetailsList"].adminDatas[index].AdminLocations.latitude = adminLocationData.latitude;
      state.adminDetailsList[accountId + "-adminDetailsList"].adminDatas[index].AdminLocations.longitude = adminLocationData.longitude;
      
    }

    var ind = state.adminLocations.findIndex(adLoc=> adLoc.adminId == adminData);
    if (ind != '-1') {
      var tdata={};
      tdata['adminId'] = adminData;
      tdata['latitude'] = adminLocationData.latitude;
      tdata['longitude'] = adminLocationData.longitude;
      tdata['srclat'] = adminLocationData.srclat;
      tdata['srclong'] = adminLocationData.srclong;
      tdata['action'] = adminLocationData.action;
      state.adminLocations.splice(ind, 1, tdata);
    } else {
      var tdata={};
      tdata['adminId'] = adminData;
      tdata['latitude'] = adminLocationData.latitude;
      tdata['longitude'] = adminLocationData.longitude;
      tdata['srclat'] = adminLocationData.srclat;
      tdata['srclong'] = adminLocationData.srclong;
      tdata['action'] = adminLocationData.action;
      state.adminLocations.push(tdata);
    }
  }

}

const actions = {
  fetchadminDetailsList({
    commit,
    dispatch
  }, postData) {
    postData.vuejs = true;
    return new Promise((resolve, reject) => {
      axios.post('/admins/admin_data', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(res => {
          commit('SET_ADMIN_DETAILS_LIST', res.data)
          resolve(res.data)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        });
    });
  },
  addAdminSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/admins/add_admin', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()

          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var dataList = {
            admindata: response.data.adminIds,
            accountId: postData.accountId
          }
          commit('ADD_ADMIN_LIST', dataList)

          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  deactivateAdminModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/admins/deactivate_admin.json', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          if (response.data.status = 'success') {
            var successData = {
              userId: postData.userId,
              accountId: postData.accountId
            }
            commit('DEACTIVATE_ADMIN', successData);
            resolve(response.data);
          }
        })
        .catch(error => console.log(error));
    });
  },
  deleteAdminModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/admins/del_admin.json', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success' && response.data.status != 'errorAdmin' && response.data.status != 'errorManager') {
            reject(response.data.message);
            return;
          } else if (response.data.status == 'errorAdmin') {
            resolve(response);
            return;
          }else if (response.data.status == 'errorManager') {
            resolve(response);
            return;
          } else {
            var successData = {
              userId: postData.userId,
              accountId: postData.accountId
            }
            commit('DELETE_ADMIN', successData);
            resolve(response);
          }
        })
        .catch(error => console.log(error));
    });
  },
  assignAdminModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/admins/assign_users_to_admin.json', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          if (response.data.status == 'success') {
            var successData = {
              userId: postData.userId,
              accountId: postData.accountId
            }
            commit('DELETE_ADMIN', successData);
            resolve(response);
          }
        })
        .catch(error => console.log(error));
    });
  },
  assignManagerModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/admins/assign_manager_to_admin.json', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          if (response.data.status == 'success') {
            var successData = {
              userId: postData.userId,
              accountId: postData.accountId
            }
            commit('DELETE_ADMIN', successData);
            resolve(response);
          }
        })
        .catch(error => console.log(error));
    });
  },
  enableEmailNotification({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/admins/enable_email_notification', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          if (response.data.status == 'success') {
            var successData = {
              userId: postData.userId,
              accountId: postData.accountId
            }
            commit('ENABLE_EMAIL_NOTIFICATION', successData);
            resolve(response.data);
          }
        })
        .catch(error => console.log(error));
    });
  },
  adminRoleEdit({
    commit,
    dispatch
  }, postData) {

    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/admins/change_admin_group', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          if (response.data.status == 'success') {
            var successData = {
              role: postData.value,
              accountId: postData.account_id,
              adminId: postData.pk
            }
            commit('CHANGE_ADMIN_GROUP', successData);
            resolve(response.data);
          }
        })
        .catch(error => console.log(error));
    });
  },
  adminManagerEdit({
    commit,
    dispatch
  }, postData) {

    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/admins/change_admin_manager', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          if (response.data.status == 'success') {
            var successData = {
              manager: postData.value,
              accountId: postData.account_id,
              adminId: postData.pk
            }
            commit('CHANGE_ADMIN_MANAGER', successData);
            resolve(response.data);
          }
        })
        .catch(error => console.log(error));
    });
  },
  adminEmailEdit({
    commit,
    dispatch
  }, postData) {

    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/admins/change_admin_email', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          if (response.data.status == 'success') {
            var successData = {
              email: postData.value,
              accountId: postData.account_id,
              adminId: postData.pk
            }
            commit('CHANGE_ADMIN_EMAIL', successData);
            resolve(response.data);
          }
        })
        .catch(error => console.log(error));
    });
  },
  adminPhoneEdit({
    commit,
    dispatch
  }, postData) {

    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/admins/change_admin_phone', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          if (response.data.status == 'success') {
            var successData = {
              phone: postData.value,
              accountId: postData.account_id,
              adminId: postData.pk
            }
            commit('CHANGE_ADMIN_PHONE', successData);
            resolve(response.data);
          }
        })
        .catch(error => console.log(error));
    });
  },
  adminPassEdit({
    commit,
    dispatch
  }, postData) {

    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/admins/change_admin_password', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          if (response.data.status == 'success') {
            var successData = {
              pass: postData.value,
              accountId: postData.account_id,
              adminId: postData.pk
            }
            commit('CHANGE_ADMIN_PASS', successData);
            resolve(response.data);
          }
        })
        .catch(error => console.log(error));
    });
  },
  notificationDetails({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      // let loader = Vue.$loading.show({
      //   canCancel: false,
      // });
      axios.post('/admins/get_notification_details', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          // loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }

          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  fetchAdminRolesDetails({
    commit,
  }, authData) {
    Nprogress.start()
    axios.get('/admins/admin_role/true')
      .then(res => {
        Nprogress.done()
        commit('SET_ADMIN_ROLES_DETAILS', res.data)
      })
      .catch(error => console.log(error))
  },
  fetchAdminControl({
    commit
  }, authData) {
    Nprogress.start()
    axios.get("/admins/admin_controls/" + authData.updateAdminName + "/" + null + "/" + null + "/" + "false" + "/" + true)
      .then(response => {
        Nprogress.done()
        commit('SET_ADMIN_CONTROL', response.data)
      })
      .catch(error => console.log(error))
  },
  deleteAdminRoleSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/admins/del_adminGroup/' + postData.id)
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = {
            adData: postData.id,
            accountId: postData.accountId
          }
          commit('DELETE_ADMIN_ROLE_LIST', successData);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  exportAdminRoleSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/admins/export_adminrole_csv')
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          window.open("/backend"+response.data.message);
        })
        .catch(error => console.log(error));
    });
  },
  saveAdminControl({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/admins/admin_controls/' + postData.updateAdName + "/" + null + "/" + null + "/" + "false" + "/" + true, qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }

          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  updateAdminControl({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/admins/admin_controls/' + postData.updateAdName + "/" + 1 + "/" + null + "/" + "false" + "/" + true, qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var dataList = {
            adData: response.data.commitArr,
            accountId: postData.accountId,
          }
          commit('ADD_ADMIN_ROLE_LIST', dataList)

          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  importAdminRoleSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios
        .post("/admins/import_adminrole_file", postData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var dataList = {
            adData: response.data.commitArr,
            accountId: postData.accountId,
          }
          commit('ADD_ADMIN_ROLE_LIST', dataList)
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },

  importAdminRoleCopySubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios
        .post("/admins/import_adminrole_file_copy", postData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var dataList = {
            adData: response.data.commitArr,
            accountId: postData.accountId,
          }
          commit('ADD_ADMIN_ROLE_LIST', dataList)
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  fetchAdminClassifyDetails({
    commit,
  }, authData) {
    Nprogress.start()
    axios.get('/network_admins/admin_classification/true')
      .then(res => {
        Nprogress.done()
        commit('SET_ADMIN_CLASSIFICATION_DETAILS', res.data)
      })
      .catch(error => console.log(error))
  },
  addAdminClassificationGrp({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/NetworkAdmins/add_admin_classification', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var dataList = {
            adminData: response.data.adminData,
            accountId: postData.accountId,
            idx: response.data.idx,
          }
          commit('ADD_ADMIN_CLASSIFY_LIST', dataList)
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  removeAdminClassificationGrp({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/NetworkAdmins/del_admin_from_group', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var dataList = {
            id: postData.admin,
            accountId: postData.accountId,
            ind: postData.idx,
          }
          commit('REMOVE_ADMIN_FROM_GROUP', dataList)

          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  addAdminClassificationToGrp({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/NetworkAdmins/add_admin_to_group', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var dataList = {
            accountId: response.data.accountId,
            adminData: response.data.adminData,
            ind: postData.idx,
          }
          commit('ADD_ADMIN_TO_GROUP', dataList)

          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  editAdminLevel({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/network_admins/edit_level', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }

          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  getAdminLocation({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      axios.post('/AccountSettings/get_admin_location', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          commit('SOCKET_SETADMINLOCATIONDATA', response.data.message)
        })
        .catch(error => console.log(error));
    });
  },
  clearAllAdminsData({
    commit,
    dispatch
  }, postData) {
    commit('CLEAR_ADMINS_STATE')
  },
}

const getters = {
  adminDetailsListGetters: state => {
    return state.adminDetailsList;
  },
  getAdminRoleListGetters: state => {
    return state.adminRoleList;
  },
  adminControlGetters: state => {
    return state.adminControlList;
  },
  getAdminClassifyListGetters: state => {
    return state.adminClassifyList;
  },
  cdnHostFromAdminGetters:state => {
    return state.cdnHost;
  },
  adminLocationDataGetters: state => {
    return state.adminLocations;
  },
}

export default {
  state,
  mutations,
  actions,
  getters
}